// extracted by mini-css-extract-plugin
export var notification_modal = "index-module--notification_modal--B5RzN";